<!-- 
  公用头部
  jay 2019-5-29
-->
<template>
  <div class="header">
    <div class="header-top">
      <div class="w-1200">
        <div class="top-l">
          <span class="welcome">
            {{ $t("common.welcome") }}
          </span>
          <div class="language">
            <span @click="changeLanguage('zh')">CN</span>
            <em>|</em>
            <span @click="changeLanguage('en')">EN</span>
          </div>
        </div>
        <div class="top-r">
          <template v-if="token">
            <p class="money">
              {{ $t("common.balance") }}：{{
                moneyEye ? userInfo.money_usable : "****"
              }}P
              <Icon
                :type="`${moneyEye ? 'md-eye' : 'md-eye-off'}`"
                @click="changeEye"
              />
            </p>
            <p class="name">
              <template v-if="userInfo.avatar">
                <img :src="httpUrl + userInfo.avatar" />
              </template>
              <template v-else>
                <img src="@/assets/images/public/default_avatar@2x.png" />
              </template>
              <span>{{ userInfo.username }}</span>
            </p>
            <a href="javascript:void(0)" @click="logout">
              {{ $t("personal.quit") }}
            </a>
          </template>
          <template v-else>
            <a href="javascript:void(0)" @click="toLogin">
              {{ $t("common.login") }}
            </a>
          </template>
        </div>
      </div>
    </div>
    <div class="head-wrapper">
      <div class="w-1200">
        <div class="logo">
          <img src="@/assets/images/public/logo.png" />
          <h1>{{ $t("common.eepay") }}</h1>
        </div>
        <div class="menu">
          <ul>
            <li
              :class="{ active: active == 1 && hover == -1 }"
              @mouseover="hoverFun(1)"
              @mouseleave="leaveFun"
              @click="toPage('/recharge/single')"
            >
              {{ $t("recharge.rechargeCenter") }}
            </li>
            <li
              :class="{ active: active == 2 && hover == -1 }"
              @mouseover="hoverFun(2)"
              @mouseleave="leaveFun"
              @click="toPage('/transfer/batch')"
            >
              {{ $t("transfer.batchTransfer") }}
            </li>
            <li
              :class="{ active: active == 3 && hover == -1 }"
              @mouseover="hoverFun(3)"
              @mouseleave="leaveFun"
              @click="toPage('/wallet/recharge')"
            >
              {{ $t("wallet.fundsManagement") }}
            </li>
            <li
              :class="{ active: active == 4 && hover == -1 }"
              @mouseover="hoverFun(4)"
              @mouseleave="leaveFun"
              @click="toPage('/personal/userInfo')"
            >
              {{ $t("personal.personalCenter") }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      active: 0,
      hover: -1,
      moneyEye: localStorage.getItem("moneyEye")
        ? JSON.parse(localStorage.getItem("moneyEye"))
        : true
    };
  },
  created() {
    this.routerFun();
  },
  mounted() {},
  computed: {
    ...mapGetters(["token", "userInfo", "language"])
  },
  methods: {
    changeLanguage(flag) {
      // 切换语言
      let vm = this;
      let language = localStorage.getItem("language");
      if (flag == language) {
        return;
      }
      localStorage.setItem("language", flag);
      vm.$store.dispatch("SET_LANGUAGE", flag);
      console.log("language", vm.language);
      window.location.reload();
    },
    changeEye() {
      // 切换金额显示
      this.moneyEye = !this.moneyEye;
      localStorage.setItem("moneyEye", this.moneyEye);
    },
    routerFun() {
      this.active = -1;
      if (this.$route.path.split("/")[1] == "recharge") {
        this.active = 1;
      }
      if (this.$route.path.split("/")[1] == "transfer") {
        this.active = 2;
      }
      if (this.$route.path.split("/")[1] == "wallet") {
        this.active = 3;
      }
      if (this.$route.path.split("/")[1] == "personal") {
        this.active = 4;
      }
    },
    hoverFun(index) {
      this.hover = index;
    },
    leaveFun() {
      this.hover = -1;
    },
    toPage(url) {
      if (this.token) {
        this.$router.push({ path: url });
      } else {
        this.toLogin();
      }
    },
    logout() {
      //退出登陆
      localStorage.clear(); //清空所有
      this.$store.dispatch("SET_TOKEN", "");
      this.$store.dispatch("GET_USER_INFO", { obj: "delete" });
      this.$router.push({
        path: "/login"
      });
    },
    toLogin() {
      this.$router.push({
        path: "/login"
      });
    }
  },
  watch: {
    $route(to, from) {
      console.log(to, from);
      this.routerFun();
    }
  },
  components: {},
  deactivated() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.header-top {
  // background: #ECECEC;
  height: 30px;
  background: linear-gradient(90deg, #2043ac 0%, #130f73 100%);
  border-bottom: 0.5px solid #9b9b9b;
  .w-1200 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 10px;
    color: #fff;
    font-size: 12px;
    .top-l {
      display: flex;
      justify-content: flex-start;
      .language {
        margin-left: 15px;
        span {
          cursor: pointer;
        }
        em {
          margin: 0 5px;
        }
      }
    }
  }
  /deep/.ivu-icon {
    width: 16px;
    margin-left: 4px;
    cursor: pointer;
  }

  .top-r {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    p {
      // color: #130F73;
      margin-right: 30px;
      font-size: 12px;
      display: flex;
      align-items: center;
      color: #fff;
      font-weight: bold;
      span {
        margin-left: 2px;
      }
    }
    img {
      margin-right: 5px;
      width: 22px;
      height: 22px;
      border-radius: 50%;
    }
  }
  a {
    width: 54px;
    height: 24px;
    border-radius: 12px;
    font-size: 12px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(270deg, #df6553 0%, #ffa000 100%);
    font-weight: 900;
  }
}
.head-wrapper {
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(32, 67, 172, 1) 0%,
    rgba(19, 15, 115, 1) 100%
  );
  .w-1200 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100px;
  }
  .logo {
    height: 100px;
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      height: 70px;
      margin-right: 10px;
    }
    h1 {
      color: #fff;
      font-size: 28px;
      font-weight: 400;
      line-height: 1;
    }
  }
  .menu {
    width: auto;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    ul {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      li {
        font-size: 16px;
        margin: 0 30px;
        color: #fff;
        cursor: pointer;
        a {
          color: #fff;
        }
        &.active,
        &:hover {
          position: relative;
          &:after {
            content: "";
            width: 100%;
            height: 3px;
            background: #fe7800;
            border-radius: 5px;
            position: absolute;
            left: 0;
            bottom: -8px;
          }
        }
      }
    }
  }
}

.headFloat .head-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: transparent;
  .w-1200 {
    justify-content: flex-end;
  }
  .logo {
    display: none;
  }
  .ivu-btn {
    color: #fff;
    background: linear-gradient(
      90deg,
      rgba(32, 67, 172, 1) 0%,
      rgba(19, 15, 115, 1) 100%
    );
    border: 0;
  }
}
</style>
